import FormMetaField from "./FormMetaField";

export default function MetaFieldList({ fields, setFields }) {
  const addField = () => {
    setFields([
      ...fields,
      {
        id: Date.now(),
        meta_name: "",
        meta_alias: "",
        required: 0,
        meta_type: "text",
        meta_value: "[]",
      },
    ]);
  };

  const updateField = (id, data) => {
    setFields(fields.map((f) => (f.id === id ? { ...f, ...data } : f)));
  };

  const removeField = (id) => {
    setFields(fields.filter((f) => f.id !== id));
  };

  return (
    <div className="bg-white shadow p-4 rounded-lg space-y-4">
      <h2 className="text-xl font-semibold">Các trường dữ liệu</h2>
      {fields.map((field) => (
        <FormMetaField
          key={field.id}
          field={field}
          updateField={updateField}
          removeField={removeField}
        />
      ))}
      <button
        onClick={addField}
        className="bg-blue-600 text-white px-3 py-2 rounded-lg"
      >
        + Thêm trường
      </button>
    </div>
  );
}
